import { jsxs as t, jsx as a } from "react/jsx-runtime";
const i = ({ size: l }) => /* @__PURE__ */ t("svg", { width: l, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ a(
    "path",
    {
      fill: "#E5E5E5",
      d: "M137.902 0a48.573 48.573 0 0 0-35.589 15.294 53.965 53.965 0 0 0-15.273 35.64v917.412a48.707 48.707 0 0 0 15.273 35.64 49.971 49.971 0 0 0 35.59 15.293h746.336a48.64 48.64 0 0 0 35.59-15.293 50.37 50.37 0 0 0 15.273-35.64V288.717L646.728 0H137.902z"
    }
  ),
  /* @__PURE__ */ a(
    "path",
    {
      fill: "#CCC",
      d: "M935.102 288.717H697.656c-27.822-.666-50.227-23.076-50.928-50.934V0l288.374 288.717z"
    }
  ),
  /* @__PURE__ */ a(
    "path",
    {
      fill: "#FFF",
      d: "M248.126 365.184h220.518a25.518 25.518 0 0 0 24.192-25.497 25.518 25.518 0 0 0-24.197-25.503H248.126a25.518 25.518 0 0 0-24.197 25.498 25.518 25.518 0 0 0 24.197 25.497zm0 169.825H773.95a25.446 25.446 0 0 0 25.43-25.466 25.446 25.446 0 0 0-25.43-25.467H248.126a25.446 25.446 0 0 0-25.431 25.467 25.446 25.446 0 0 0 25.43 25.466zM773.95 653.896H248.126a25.518 25.518 0 0 0-24.197 25.497 25.518 25.518 0 0 0 24.197 25.503H773.95a25.518 25.518 0 0 0 24.197-25.497A25.518 25.518 0 0 0 773.95 653.9z"
    }
  )
] });
export {
  i as AnyFileIcon
};
//# sourceMappingURL=AnyFileIcon.js.map
